import { useCategoryCardContext } from "../DashboardCards";

const useDirection = () => {
  const { isMobile, fullWidth } = useCategoryCardContext();
  if (fullWidth && !isMobile) return "row";
  return "column";
};

export { useDirection };
